import { TypeArticle, TypeCategorySorting } from '~/types/contentful'
import { ArticleBigPreview } from '../Article'
import { PostsPreviewGroup } from '../PostsPreviewGroup'
import { FlexContainer, FlexItem } from '~/components/Grid'

export type BlogPostsProps = {
  postGroups: Array<
    | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>[]
    | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
  >
  categories: TypeCategorySorting<'WITHOUT_UNRESOLVABLE_LINKS', string>
  isCategoryPage?: boolean
}

export const BlogPosts = ({ postGroups, categories, isCategoryPage }: BlogPostsProps) => {
  const findIndex = isCategoryPage ? 0 : 1

  if (!postGroups) {
    return (
      <div className="max-md:pt-10 max-xl:text-center bg-white text-neutral-100 pt-15 min-h-[500px] rounded-bl-[40px]">
        <FlexContainer justify="end">
          <FlexItem desktop={10}>
            <p className="text-l">Posts Not Found</p>
          </FlexItem>
        </FlexContainer>
      </div>
    )
  }
  return (
    <div>
      {postGroups.map((item, index) => {
        if (Array.isArray(item)) {
          return (
            <PostsPreviewGroup
              key={item[0].fields.slug}
              posts={item}
              categories={index === findIndex ? categories : undefined}
            />
          )
        }
        return <ArticleBigPreview key={item.fields.slug} data={item} />
      })}
    </div>
  )
}
